/*
 * @Author: Lina
 * @Date: 2020-06-29 11:25:59
 * @LastEditors: Lina
 * @LastEditTime: 2020-06-29 19:20:42
 */ 
// 快应用通讯

const Action = {
  openWebView: 'openWebView',
  goPay: 'goPay',
  goBack: 'goBack',
  navigateTo: 'navigateTo',
}

const createMessage = (actionName, data) => {
  try {
    const param = data
    const reg = /^http(s)?:\/\/(.*?)\//
    Object.keys(param).forEach((key) => {
      if (typeof param[key] === 'string' && reg.test(param[key])) {
        param[key] = encodeURIComponent(param[key])
      }
    })
    return `${actionName}+%%%+${JSON.stringify(param)}`
  } catch (error) {
    return ''
  }
}

const postMessage = (actionName, data) => {
  if (window && window.crgt && window.crgt.isQA) {
    try {
      window.system.postMessage(createMessage(actionName, data))
    } catch (error) {
      console.error(error)
    }
  }
}

export default {
  postMessage,
  createMessage,
  Action
}

